export enum Viewport {
  PHONE_ONLY = 'PHONE_ONLY',
  TABLET_PORTRAIT_UP = 'TABLET_PORTRAIT_UP',
  TABLET_LANDSCAPE_UP = 'TABLET_LANDSCAPE_UP',
  DESKTOP = 'DESKTOP',
}
